import { Component } from 'react'
import * as styles from 'styles/atoms/tables/PageSizeSelector.css'
import * as cn from 'classnames'

export type PageSizeSelectorStateProps = {
  options: number[]
  current: number
}

type PageSizeSelectorDispatchProps = {
  onPageSizeChange: (pageSize: number) => void
}

type PageSizeSelectorProps = PageSizeSelectorStateProps & PageSizeSelectorDispatchProps

class PageSizeSelector extends Component<PageSizeSelectorProps, {}> {
  render () {
    const { options, current, onPageSizeChange } = this.props

    if (!options.length) {
      return null
    }

    return (
      <div className={ styles.pageSizeSelector }>
        <span className={ styles.label }>Show</span>
        <ul className={ styles.options }>
          {
            options.map((pageSize) => {
              const isCurrent = pageSize === current
              const className = cn(styles.option, { [styles.current]: isCurrent })
              const onClick = isCurrent ? undefined : () => onPageSizeChange(pageSize)

              return (
                <li key={ pageSize } { ...{ className, onClick } } data-qa-marker={ `page-size-${ pageSize }` }>
                  { pageSize }
                </li>
              )
            })
          }
        </ul>

      </div>
    )
  }
}

export default PageSizeSelector
